import React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import PropTypes from "prop-types";
import Modal from "../../../../reusable/Modal/Modal.index";
import RadioGroup from "../../../../reusable/Form/RadioGroup";
import {DASHBOARD_EXPORT_OPTIONS, MICROSOFT_EXCEL_FORMAT} from "../../../../constants";
import ExportDashboardController from "./ExportDashboardController";

let dateFormat = require('dateformat');

export class ExportDashboardModal extends React.Component {

    static propTypes = {
        secondaryAction: PropTypes.func,
        shouldDisplayDate: PropTypes.bool
    };

    static defaultProps = {
        shouldDisplayDate: true
    };

    date = new Date();
    uiDate = dateFormat(this.date, "mm_dd_yyyy");
    uiTime = dateFormat(this.date, "HH:MM");
    fileName = this.props.shouldDisplayDate
        ? "EI_Dashboard_download_" + this.uiDate + "_" + this.uiTime
        : "Testing_file_name";

    state = {
        exportOption: DASHBOARD_EXPORT_OPTIONS.CURRENT_VIEW,
        fileOption: MICROSOFT_EXCEL_FORMAT,
        fileNameInputValue: this.fileName
    };

    setExportFiltersOption = event => {
        this.setState({
            exportOption: event.target.value
        });
    };

    setExportFileFormatOption = event => {
        this.setState({
            fileOption: event.target.value
        });
    };

    changeFileNameHandler = event => {
        this.setState({fileNameInputValue: event.target.value});
    };

    handleDashboardExport = () => {
        this.props.secondaryAction();
        ExportDashboardController.exportDashboard(
            this.state.exportOption,
            this.state.fileNameInputValue,
            this.props.dashboardState
        );
    };

    radioExportOptions = [
        {
            value: DASHBOARD_EXPORT_OPTIONS.CURRENT_VIEW,
            label: <FormattedMessage id="Dashboard_CoreFunctionality_UIText_exportModal.exportCurrentView"/>
        },
        {
            value: DASHBOARD_EXPORT_OPTIONS.ALL_DATA,
            label: <FormattedMessage id="Dashboard_CoreFunctionality_UIText_exportModal.exportAllData"/>,
        }
    ];

    radioFileFormat = [
        {
            value: MICROSOFT_EXCEL_FORMAT,
            label: <FormattedMessage id="Dashboard_CoreFunctionality_UIText_exportModal.excelFormat"/>
        }
    ];

    render() {
        return (
            <div id='ModalExportDashboard' className='entities-download-modal'>

                <Modal closeButtonHandler={this.props.secondaryAction}
                       buttons={
                           [
                               {
                                   text: <FormattedMessage
                                       id={"Dashboard_CoreFunctionality_UIText_modalActions.export"}/>,
                                   click: () => this.handleDashboardExport(),
                                   primary: true
                               },
                               {
                                   text: <FormattedMessage
                                       id={"General_CoreFunctionality_UIText_general.cancel"}/>,
                                   click: this.props.secondaryAction,
                                   tabIndex: 1
                               }
                           ]
                       }>

                    <div>
                        <h2 className="modal-header">
                            <FormattedMessage id={"Dashboard_CoreFunctionality_UIText_export"}/>
                        </h2>
                        <div className='modal-body-container'>
                            <FormattedMessage id={"Dashboard_CoreFunctionality_UIText_exportModal.option"}/>
                            <RadioGroup value={this.state.exportOption}
                                        fieldId={"options-selector"}
                                        onChange={this.setExportFiltersOption}
                                        options={this.radioExportOptions}/>
                            <FormattedMessage id={"Dashboard_CoreFunctionality_UIText_exportModal.fileFormat"}/>
                            <RadioGroup value={this.state.fileOption}
                                        fieldId={"file-format"}
                                        options={this.radioFileFormat}
                                        onChange={this.setExportFileFormatOption}
                            />
                            <FormattedMessage id={"Dashboard_CoreFunctionality_UIText_exportModal.fileName"}/>
                            <div className="input-container">
                                <input type="text"
                                       className="file-name-input"
                                       onChange={this.changeFileNameHandler}
                                       value={this.state.fileNameInputValue}/>
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}

export default injectIntl(ExportDashboardModal);


// WEBPACK FOOTER //
// ./src/scripts/pages/StartPage/Dashboard/components/ExportDashboardModal.jsx